<template>
  <div>
    <h1>Sign In</h1>

    <KadoMenu />

    <table class="table-signin">
      <tr>
        <td>
          Username:
        </td>
        <td>
          <div class="div-signin-inputText">
            <input class="inputText-common" type="text" placeholder="username" v-model="username" required />
          </div>
        </td>
      </tr>
      <tr>
        <td>
          Password:
        </td>
        <td>
          <div class="div-signin-inputText">
            <input class="inputText-common" type="password" placeholder="password" v-model="password" required />
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="div-signin-button">
            <button class="button-normal button-normal__extra" @click="signIn"><font-awesome-icon icon="sign-in-alt" /> Sign In</button>
          </div>
        </td>
      </tr>
    </table>

    <div class="div-procMsg-normal" v-if="procMsgNormal">{{ procMsgNormal }}</div>
    <div class="div-procMsg-attention" v-if="procMsgAttention">{{ procMsgAttention }}</div>
  </div>
</template>

<script>
// 共通定数
import { MyConfig as mc } from '@/MyConfig'
// 認証モジュール
import { MyAuth } from '@/my-modules/my-auth'
// コンポーネント：角メニュー
import KadoMenu from '@/components/KadoMenu.vue'

export default {
  name: 'SignIn',

  components: {
    KadoMenu
  },

  data () {
    return {
      username: '',
      password: '',
      procMsgNormal: '',
      procMsgAttention: ''
    }
  },

  methods: {
    /* =================================================================================
     * signIn
     *   サインインを行う
     * ============================================================================== */
    async signIn () {
      mc.LOG_LEVEL ? console.log('%c info: Method=signIn: Start', mc.LOG_TYPE_I) : (() => { })()
      if (this.username && this.password) {
        try {
          const myAuth = new MyAuth()
          const res = await myAuth.signIn(this.username, this.password)
          if (res.status === 'OK') {
            mc.LOG_LEVEL ? console.log('%c info: Method=signIn: OK', mc.LOG_TYPE_I) : (() => { })()
            this.$router.push('/')
          } else if (res.status === 'NOAUTH') {
            mc.LOG_LEVEL ? console.log('%c info: Method=signIn: NOAUTH', mc.LOG_TYPE_I) : (() => { })()
            this.procMsgNormal = res.content
          }
        // モジュールmyAuth(promise)からのrejectや例外エラーをcatch
        } catch (e) {
          mc.LOG_LEVEL ? console.log('%c error: Method=signIn: e:', mc.LOG_TYPE_E, e) : (() => { })()
          this.procMsgAttention = 'Failed to sign in at the moment, try back later.'
        }
      }
      mc.LOG_LEVEL ? console.log('%c info: Method=signIn: End', mc.LOG_TYPE_I) : (() => { })()
    }
  }
}
</script>

<style scoped>
.table-signin {
  margin-left: auto;
  margin-right: auto;
}
.div-signin-inputText {
  width: 10em;
  margin: 0 0.2em 0.2em 0.2em;
}
.div-signin-button {
  padding: 1em 0;
  text-align: center;
}
.button-normal__extra {
  width: 10em;
}
</style>
